module.exports = __webpack_public_path__ + "static/media/cogs.14766b1c.svg";